import routes from './routesOnNav';
import { addComponentsToRoutes } from 'services/common';
import Phase2 from 'containers/AutomatedCampaignGeneration/Phase2';
import Phase1 from 'containers/AutomatedCampaignGeneration/Phase1';
import Phase3 from 'containers/AutomatedCampaignGeneration/Phase3';
import Phase4 from 'containers/AutomatedCampaignGeneration/Phase4';

const components = {
  '/acg/phase-1': Phase1,
  '/acg/phase-2': Phase2,
  '/acg/phase-3': Phase3,
  '/acg/phase-4': Phase4,
};

export default addComponentsToRoutes(routes, components);
